import { captureException } from '@sentry/react'

export const PACKED_UUID_KEY = '__p'
export type PackedUUIDs = { [PACKED_UUID_KEY]: string }

const hexToBytes = (hex: string): number[] => {
  const bytes: number[] = []

  for (let c = 0; c < hex.length; c += 2) {
    bytes.push(parseInt(hex.substring(c, c + 2), 16))
  }

  return bytes
}

const bytesToHex = (bytes: number[]): string => {
  return bytes.map(b => b.toString(16).padStart(2, '0')).join('')
}

export const packUuidList = (uuids: string[]): PackedUUIDs => {
  const allBytes: number[] = []

  for (const uuid of uuids) {
    const hex = uuid.replace(/-/g, '')

    allBytes.push(...hexToBytes(hex))
  }

  const CHUNK_SIZE = 0x8000
  const chars: string[] = []

  for (let i = 0; i < allBytes.length; i += CHUNK_SIZE) {
    chars.push(String.fromCharCode.apply(null, allBytes.slice(i, i + CHUNK_SIZE)))
  }

  const binaryStr = chars.join('')

  return { [PACKED_UUID_KEY]: btoa(binaryStr) }
}

export const unpackUuidList = (packed: PackedUUIDs): string[] => {
  try {
    const binaryStr = atob(packed[PACKED_UUID_KEY])
    const bytes: number[] = []

    for (let i = 0; i < binaryStr.length; i++) {
      bytes.push(binaryStr.charCodeAt(i))
    }

    const uuids: string[] = []

    for (let i = 0; i < bytes.length; i += 16) {
      const chunk = bytes.slice(i, i + 16)

      if (chunk.length === 16) {
        const hex = bytesToHex(chunk)
        const uuid = [
          hex.substring(0, 8),
          hex.substring(8, 12),
          hex.substring(12, 16),
          hex.substring(16, 20),
          hex.substring(20, 32),
        ].join('-')

        uuids.push(uuid)
      }
    }

    return uuids
  } catch (e) {
    captureException(e)
    return []
  }
}
